<template>
  <v-container class="d-flex justify-center">
    <v-card max-width="600">
      <v-card-title>
        <v-icon size="60" color="green">check_circle</v-icon>
        <h4 class="text-h4">Orden creada</h4>
      </v-card-title>

      <v-card-text v-if="error" class="text-center">
        <v-alert type="error">{{ error }}</v-alert>
        <br>
        <v-btn class="my-2" color="indigo white--text" @click="redirectToHome">Inicio</v-btn>
      </v-card-text>

      <template v-else>

        <v-card-text class="text-center">

        </v-card-text>
        <v-card-text class="body-1">
          Tu orden ha sido creada, vas a recibir un email con el resumen.
        </v-card-text>
        <v-card-text class="text-center">
          <v-btn color="indigo white--text" @click="redirectToFollowOrder">Seguir orden</v-btn>
        </v-card-text>

      </template>


    </v-card>
  </v-container>
</template>

<script>

export default {
  name: "CustomerOrderCreatedPage",
  components: {},
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  created() {
    if (!this.hasOrder && this.routeIdentifier) {
      this.fetchOrder()
    }
  },
  computed: {
    routeIdentifier() {
      return this.$route.params.identifier;
    },
    hasOrder() {
      return this.$store.getters.hasOrder;
    },
    order() {
      return this.$store.getters.orderSystem.order
    },
    orderIdentifier() {
      return this.$store.getters.orderSystem.order.identifier
    },
  },
  methods: {
    async fetchOrder() {
      try {
        this.loading = true
        await this.$store.dispatch('findOrderByIdentifier', this.routeIdentifier)
      } catch (error) {
        console.error(error)
        this.error = error.message || 'Hubo un error al obtener la orden'
      } finally {
        this.loading = false
      }

    },
    redirectToFollowOrder() {
      this.$router.push({
        name: 'CustomerOrderViewPage',
        params: {identifier: this.orderIdentifier}
      })
    },
    redirectToHome() {
      this.$router.push({
        name: 'home'
      })
    }
  }
}
</script>

<style scoped>

</style>
